/* eslint-disable */
// GENERATED FILE — do not edit. Run `npm run catalog:build` after changing catalog/**.
// Source of truth: catalog/<area>/<ID>.md. `npm run catalog:check` fails when this is stale.
import type { CatalogEntry } from './types';

/** Fingerprint of the catalog sources this file was built from. */
export const CATALOG_HASH = '2fa30c17ff9e6dcdd5511205101b6b69892ce94806723d1a94508e7f62229f49';

export const CATALOG_ENTRIES: readonly CatalogEntry[] =
  [
    {
      "id": "BEN-001",
      "area": "benefits",
      "job": "Enrol in a benefit package",
      "description": "On the Benefits page open the \"Eligible\" tab and click \"Enrol\" on the package's card. Choose the start date — it cannot be in the past and must lie within your eligibility period — give any consent the form asks for, and send it. A package that needs approval shows \"In review\" until it is decided.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Eligible\" tab; your consent must be given on the Profile page.",
      "aliases": [
        "sign up for a benefit",
        "join a package",
        "apply for a benefit",
        "get insurance",
        "enroll",
        "register for a benefit"
      ],
      "anchor": "benefits-card-enroll",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-002",
      "area": "benefits",
      "job": "Enrol a dependant in a benefit",
      "description": "Dependants are added on the Profile page first. Then on the Benefits page click the dependant's tag above the cards — everything on the page, including \"Enrol\", now works for that person — and enrol them in a package that allows dependants.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "The dependant must be added on the Profile page.",
      "aliases": [
        "enrol my child",
        "add my spouse to insurance",
        "family member benefit",
        "benefit for my kids",
        "insure my partner"
      ],
      "anchor": "benefits-person-select",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-003",
      "area": "benefits",
      "job": "Upgrade to another package of the same benefit",
      "description": "When the selected person already has a package of a benefit, the other packages of that benefit show \"Upgrade\" instead of \"Enrol\". Upgrading replaces the current package of that benefit from the date you choose. The button is disabled while another package of the same benefit is still in review.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Eligible\" tab.",
      "aliases": [
        "upgrade",
        "change package",
        "switch to a better package",
        "higher tier",
        "replace my package"
      ],
      "anchor": "benefits-card-enroll",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-004",
      "area": "benefits",
      "job": "Cancel a benefit package",
      "description": "On the \"Enrolled\" tab click \"Cancel\" on the package's card. Pick the last day of the package — not in the past and not before the earliest cancellation date shown in the form — and give a reason (required, up to 4000 characters). A cancellation that needs approval shows \"In review\" until it is decided.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Enrolled\" tab; shown only while the package can still be cancelled.",
      "aliases": [
        "stop a benefit",
        "end my insurance",
        "unsubscribe",
        "terminate a package",
        "opt out",
        "quit a benefit"
      ],
      "anchor": "benefits-card-cancel",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-005",
      "area": "benefits",
      "job": "See requests still waiting for approval",
      "description": "Click \"Filter\" at the right end of the tab row and tick \"In review\". Only the enrolments and cancellations that still wait for approval are listed; untick it to see all packages again.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "pending",
        "in review",
        "awaiting approval",
        "not approved yet",
        "status of my request"
      ],
      "anchor": "benefits-status-filter",
      "anchor_surface": "benefits-filter-button",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-006",
      "area": "benefits",
      "job": "Find out why a request was rejected",
      "description": "When an enrolment or cancellation was rejected, \"View details\" on the package's card turns red with a warning icon. Open it to read which request was rejected and the reviewer's comment; you can send a new request from the card.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "rejected",
        "declined",
        "why was my enrolment refused",
        "denied request",
        "reason for rejection"
      ],
      "anchor": "benefits-card-details",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-007",
      "area": "benefits",
      "job": "Filter benefits by category",
      "description": "Click \"Filter\" at the right end of the tab row and tick the categories you want to see. \"Clear all\" hides every card until you tick one again; \"Select all\" brings them back. Each tab remembers its own filter.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "filter",
        "show only health",
        "category",
        "narrow the list",
        "find a type of benefit"
      ],
      "anchor": "benefits-category-filter",
      "anchor_surface": "benefits-filter-button",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-008",
      "area": "benefits",
      "job": "See expired or past packages",
      "description": "The \"Expired\" tab lists packages whose validity period has ended. On the \"Enrolled\" and \"Eligible\" tabs the \"Show expired\" switch adds them to those lists too.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "old packages",
        "past benefits",
        "history",
        "ended packages",
        "expired"
      ],
      "anchor": "benefits-content-tabs",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-009",
      "area": "benefits",
      "job": "Read a package's terms and documents",
      "description": "\"View details\" on the package's card opens the full description, the validity period, your price and the documents attached to the package. Click a document to open it in a new browser tab.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "terms and conditions",
        "policy conditions",
        "package documents",
        "what is covered",
        "details of a benefit"
      ],
      "anchor": "benefits-card-details",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-010",
      "area": "benefits",
      "job": "Give the salary deduction consent",
      "description": "A package paid by salary deduction asks for a signed consent in the enrolment form when none is on file for it yet. Download the template there (when your employer has provided one), sign it and upload it; the enrolment cannot be sent without it.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Start an enrolment: \"Eligible\" tab → \"Enrol\" on the package.",
      "aliases": [
        "salary deduction",
        "payroll deduction",
        "deduct from my salary",
        "signed consent form",
        "consent template"
      ],
      "anchor": "benefits-enroll-salary-deduction",
      "anchor_surface": "benefits-card-enroll",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-011",
      "area": "benefits",
      "job": "Check how much a package costs me",
      "description": "Each benefit card shows your own share of the price, the currency and how often it is paid. When the split with your employer is a percentage, the card already shows your amount; the Dashboard adds everything up.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "price",
        "how much do I pay",
        "my share",
        "monthly cost",
        "contribution"
      ],
      "anchor": "benefits-card-price",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-012",
      "area": "benefits",
      "job": "Find the earliest date I can cancel",
      "description": "\"View details\" on the package's card shows, on the right, the earliest date from which the package can be cancelled. The cancellation form repeats it, and a cancellation date before it is not accepted.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "notice period",
        "when can I cancel",
        "minimum period",
        "cancellation date",
        "lock-in"
      ],
      "anchor": "benefits-card-details",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "BEN-013",
      "area": "benefits",
      "job": "Upload the insurer's signed consent form",
      "description": "Some packages need the insurer's consent before you can enrol. The enrolment form then shows the insurer's text, a link or a form to download; when the form has to be uploaded, sign it and add one or more scans in the form before sending the enrolment.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Start an enrolment: \"Eligible\" tab → \"Enrol\" on the package.",
      "aliases": [
        "insurer consent",
        "insurance company form",
        "scan the form",
        "upload signed form",
        "medical consent"
      ],
      "anchor": "benefits-enroll-insurer-consent",
      "anchor_surface": "benefits-card-enroll",
      "source_ref": "help:BenefitsPage"
    },
    {
      "id": "DSH-001",
      "area": "dashboard",
      "job": "See the total cost of my benefits",
      "description": "The Dashboard shows the full price of all packages active today, for you and your dependants together — your employer's share plus yours. With packages in several currencies, pick the currency at the top; amounts are never converted.",
      "roles": [
        "employee"
      ],
      "deeplink": "/dashboard",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "total cost",
        "how much are my benefits worth",
        "overview of costs",
        "sum of benefits",
        "benefit value"
      ],
      "anchor": "dashboard-total-card",
      "source_ref": "help:Dashboard"
    },
    {
      "id": "DSH-002",
      "area": "dashboard",
      "job": "See what I pay and what my employer pays",
      "description": "The Dashboard splits the total into what your employer pays and what you pay for yourself and your dependants. \"Your share\" is your part of the total; the box chart below shows the split, with the exact amounts underneath.",
      "roles": [
        "employee"
      ],
      "deeplink": "/dashboard",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "my contribution",
        "employer contribution",
        "who pays",
        "my share",
        "company pays",
        "what my employer pays",
        "employer share",
        "how much does my employer pay"
      ],
      "anchor": "dashboard-financial-chart",
      "source_ref": "help:Dashboard"
    },
    {
      "id": "DSH-003",
      "area": "dashboard",
      "job": "Compare costs per benefit category",
      "description": "The per-category panel on the Dashboard lists the total cost of each benefit category, each bar showing its share of the overall total. At most four categories are listed.",
      "roles": [
        "employee"
      ],
      "deeplink": "/dashboard",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "costs by category",
        "breakdown",
        "health vs mobility costs",
        "category totals"
      ],
      "anchor": "dashboard-per-category",
      "source_ref": "help:Dashboard"
    },
    {
      "id": "DSH-004",
      "area": "dashboard",
      "job": "See the cost of my dependants' benefits",
      "description": "The dependants' chart on the Dashboard shows only the packages your dependants are enrolled in: what your employer pays for them, what you pay and the total. It shows zero when no dependant is enrolled.",
      "roles": [
        "employee"
      ],
      "deeplink": "/dashboard",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "family costs",
        "children benefit cost",
        "spouse cost",
        "dependants total"
      ],
      "anchor": "dashboard-dependent-chart",
      "source_ref": "help:Dashboard"
    },
    {
      "id": "EMP-001",
      "area": "employer",
      "job": "Read the documents your employer shared",
      "description": "The Employer page lists every document your employer has shared with all employees — benefit rules, policy conditions — with the date it was last changed. Click a name to open it in a new browser tab.",
      "roles": [
        "employee"
      ],
      "deeplink": "/employer",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "company documents",
        "employer files",
        "benefit rules",
        "hr documents",
        "policy from my employer"
      ],
      "anchor": "employer-documents",
      "source_ref": "help:EmployerPage"
    },
    {
      "id": "GEN-001",
      "area": "general",
      "job": "Ask the AI assistant a question",
      "description": "The round chat button at the bottom right (on a phone: \"Ask a question\" in the bottom bar) opens the assistant. Type your question in your own words and press Enter; it answers for the person selected on the Benefits page. Answers are generated by AI and can be wrong, so check anything important in your documents.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Your consent must be given on the Profile page.",
      "aliases": [
        "chat",
        "chatbot",
        "ask a question",
        "talk to the assistant",
        "ai help",
        "question about my cover"
      ],
      "anchor": "app-chat-toggle",
      "anchor_action": "open",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-002",
      "area": "general",
      "job": "Switch to another employer",
      "description": "The employer name at the top of the side navigation shows whose benefits you are looking at. If your account is linked to more than one employer, click it and pick another one; the app switches to that employer's benefits and returns to the start page.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "change employer",
        "change company",
        "switch company",
        "other employer",
        "wrong employer",
        "select client"
      ],
      "anchor": "nav-client-switcher",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-003",
      "area": "general",
      "job": "Change the app language",
      "description": "Open the settings with the gear icon in the top bar (on a phone: your picture at the top right) and pick a language. The choice is remembered in this browser for your next visit.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "language",
        "change language",
        "switch language",
        "german",
        "english",
        "translate the app"
      ],
      "anchor": "app-settings-language",
      "anchor_surface": "app-settings",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-004",
      "area": "general",
      "job": "Turn on dark mode or change the colours",
      "description": "Open the settings with the gear icon in the top bar. The dark-mode switch shows light text on a dark background, and the colour buttons repaint buttons and highlights; both choices are remembered in this browser. The switch above dark mode shows or hides the pictures on benefit cards.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "dark mode",
        "dark theme",
        "night mode",
        "colour theme",
        "change colours",
        "hide pictures"
      ],
      "anchor": "app-settings-dark-mode",
      "anchor_surface": "app-settings",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-005",
      "area": "general",
      "job": "Contact support",
      "description": "\"Support\" at the bottom of the side navigation opens a new e-mail to the support team in your mail program. Describe what you tried to do and on which page; copying the error from the notifications (the bell) into the mail helps the team reproduce it.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "help desk",
        "report a problem",
        "something is not working",
        "email support",
        "contact hr",
        "error"
      ],
      "anchor": "nav-support",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-006",
      "area": "general",
      "job": "Read the privacy notice",
      "description": "\"Privacy notice\" at the bottom of the side navigation opens the notice that applies in your employer's country in a new browser tab. It explains how your personal data and the data of your dependants is processed.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "gdpr",
        "data protection",
        "privacy policy",
        "how is my data used",
        "personal data"
      ],
      "anchor": "nav-privacy-notice",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-007",
      "area": "general",
      "job": "Sign out of the app",
      "description": "\"Sign out\" at the bottom of the side navigation ends your session. Do this on a shared or public computer; anything not yet saved in an open form is lost.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "log out",
        "logout",
        "sign off",
        "exit the app",
        "end session"
      ],
      "anchor": "nav-sign-out",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-008",
      "area": "general",
      "job": "Open your employer's user manual",
      "description": "The book icon in the top bar opens the user manual of your employer's benefit programme as a document in a new browser tab. If no manual has been uploaded for your employer yet, the app says so in the notifications instead.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "user manual",
        "handbook",
        "programme rules",
        "manual pdf",
        "instructions document"
      ],
      "anchor": "app-user-manual",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-009",
      "area": "general",
      "job": "Find out what a field or button does",
      "description": "The \"?\" in the top bar opens the page guide for the page you are on. \"Show me around\" walks through the controls on screen, \"Point at a field\" explains the control you click, and the search box finds an entry by any word in its explanation.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "help",
        "page guide",
        "tour",
        "what does this button do",
        "explain this page",
        "user guide"
      ],
      "anchor": "app-help-launcher",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "GEN-010",
      "area": "general",
      "job": "See the messages and errors the app showed",
      "description": "The bell in the top bar lists the confirmations and errors shown during this visit, with their count on the badge. Each message can be copied, which is useful when contacting support, or dismissed; the list is emptied when you reload the page.",
      "roles": [
        "employee"
      ],
      "deeplink": "/benefits",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "notifications",
        "bell",
        "error message",
        "copy the error",
        "messages"
      ],
      "anchor": "app-notifications",
      "source_ref": "help:../components/AppLayout/shell"
    },
    {
      "id": "PRO-001",
      "area": "profile",
      "job": "Give your consent to start using the app",
      "description": "On first sign-in the Profile page asks for your consent to the processing of your personal data. Tick the box (the link opens the full text), fill in the required fields and save; Benefits, Employer and Dashboard open after that first save.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Shown only until the consent has been accepted for the first time.",
      "aliases": [
        "accept consent",
        "pages are locked",
        "menu is greyed out",
        "first login",
        "unlock the app",
        "agree to terms"
      ],
      "anchor": "profile-main-consent",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-002",
      "area": "profile",
      "job": "Add a dependant",
      "description": "On the Profile page open the \"Dependants\" tab and click \"Add dependant\". Choose how the person is related to you, enter the name and date of birth (required) and save; the dependant can then be enrolled in benefits that allow dependants.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Dependants\" tab.",
      "aliases": [
        "add my child",
        "add spouse",
        "add family member",
        "register a dependant",
        "add partner",
        "new dependent"
      ],
      "anchor": "profile-add-dependent",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-003",
      "area": "profile",
      "job": "Change or delete a dependant",
      "description": "On the \"Dependants\" tab click the pencil next to the dependant. Edit the details and save, change their picture, or delete them after confirming.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Dependants\" tab.",
      "aliases": [
        "edit dependant",
        "remove my child",
        "delete family member",
        "update dependent details",
        "wrong birth date of my child"
      ],
      "anchor": "profile-dependent-edit",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-004",
      "area": "profile",
      "job": "Update your address, phone or e-mail",
      "description": "On the Profile page, \"Personal details\" tab, change the fields and press save. The e-mail address and the mobile phone number are required; the address fields are optional.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "change address",
        "moved house",
        "new phone number",
        "change email",
        "update contact details",
        "personal data"
      ],
      "anchor": "profile-address",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-005",
      "area": "profile",
      "job": "Change your profile picture",
      "description": "Click the round upload button on your picture on the Profile page. Pick a ready-made avatar and confirm, or upload an image of your own, which is saved straight away.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "aliases": [
        "avatar",
        "photo",
        "profile photo",
        "change picture",
        "upload picture"
      ],
      "anchor": "profile-avatar-button",
      "anchor_action": "open",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-006",
      "area": "profile",
      "job": "Upload a document to your profile",
      "description": "On the Profile page open the \"Documents\" tab, click \"Upload\" and choose the file, then press the save button that appears next to it. The document then appears in the list with today's date.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Documents\" tab.",
      "aliases": [
        "upload a file",
        "send a certificate",
        "attach document",
        "add document",
        "upload scan"
      ],
      "anchor": "profile-document-upload",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-007",
      "area": "profile",
      "job": "See the consents you have given",
      "description": "The \"Consents\" tab of the Profile page lists every consent you have given — the privacy notice and sensitive-data consent, and the salary-deduction and insurer consents signed when enrolling — with the date. Click a name to open the document.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Consents\" tab.",
      "aliases": [
        "my consents",
        "signed forms",
        "what did I agree to",
        "consent history",
        "gdpr consent"
      ],
      "anchor": "profile-consent-document",
      "source_ref": "help:ProfilePage"
    },
    {
      "id": "PRO-008",
      "area": "profile",
      "job": "Withdraw your consents",
      "description": "On the \"Consents\" tab, \"Revoke\" withdraws every consent you have given after you confirm, and signs you out. The next time you sign in you have to accept the consent again before the other pages open.",
      "roles": [
        "employee"
      ],
      "deeplink": "/profile",
      "status": "published",
      "owner": "hbh-team",
      "prerequisites": "Open the \"Consents\" tab.",
      "aliases": [
        "revoke consent",
        "withdraw consent",
        "delete my data",
        "stop processing my data",
        "opt out of gdpr"
      ],
      "anchor": "profile-revoke-consents",
      "source_ref": "help:ProfilePage"
    }
  ] as readonly CatalogEntry[];
